import * as React from "react";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { memo } from "react";

export default memo(function ProgressBar({
  time,
  height = 25,
  breakTime = 15 * 60 * 1000,
}) {
  const [progress, setProgress] = React.useState((time * 100) / breakTime);

  React.useEffect(() => {
    const timer = setInterval(() => {
      if (progress <= 100) {
        setProgress((prevProgress) =>
          prevProgress > 100 ? 1000 : prevProgress + 0.25
        );
      }
      // console.log(progress);
    }, 2250);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: height,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      // backgroundColor:
      //   theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
      backgroundColor:
        progress <= 100
          ? theme.palette.mode === "light"
            ? "#b5d9a7"
            : "#7faf72"
          : theme.palette.mode === "light"
          ? "#d32f2f"
          : "#ec3333",
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor:
        progress <= 100
          ? theme.palette.mode === "light"
            ? "#1e8804"
            : "#3c9d24"
          : theme.palette.mode === "light"
          ? "#b41414"
          : "#ec3333",
    },
  }));

  return (
    <Box sx={{ width: "100%" }}>
      <BorderLinearProgress variant="determinate" value={progress} />
    </Box>
  );
});
